// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"d0d8b55e","751":"1ab0a68e"}[chunkId] + ".chunk.css";
};